export * from './copyright.component';
